/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Camera_Location_SaveInputs */

const vi_camera_location_save = /** @type {(inputs: Camera_Location_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lưu nơi đặt`)
};

/**

* @param {Camera_Location_SaveInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const camera_location_save = /** @type {((inputs?: Camera_Location_SaveInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Camera_Location_SaveInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_camera_location_save(inputs)
});